<template>
  <div>
    <Table :columns="columns" :data="resources" size="small" stripe>
      <template slot-scope="{ row }" slot="contract_start_date">
        {{ row.contract_start_date }}
      </template>
      <template slot-scope="{ row }" slot="contract_period">
        {{ row.contract_period }}
      </template>
      <template slot-scope="{ row }" slot="guarantor_name">
        {{ row.guarantor_name }}
      </template>
      <template slot-scope="{ row }" slot="guarantor_name_2">
        {{ row.guarantor_name_2 }}
      </template>
      <template slot-scope="{ row }" slot="grt_province_code_name_en">
        {{ row.grt_province_code_name_en }}
      </template>
      <template slot-scope="{ row }" slot="grt_district_code_name_en">
        {{ row.grt_district_code_name_en }}
      </template>
      <template slot-scope="{ row }" slot="grt_commune_code_name_en">
        {{ row.grt_commune_code_name_en }}
      </template>
      <template slot-scope="{ row }" slot="grt_village_name_en">
        {{ row.grt_village_name_en }}
      </template>

      <template slot-scope="{ row }" slot="action">
        <a
          href="#"
          class="text-blue mr-2 ts-z-30"
          @click.prevent="onPreviewPdf(row)"
          v-tooltip="$t('employee.previewContract')"
        >
          <Icon type="ios-document" size="20" />
        </a>
      </template>
    </Table>
    <pdf-preview v-model="pdf_view" :contract_id="contract_id" />
  </div>
</template>
<script>
import { orderBy } from 'lodash'
import PdfPreview from './pdf-preview.vue'

export default {
  props: {
    row: Object
  },
  components: {
    PdfPreview
  },
  data () {
    return {
      loading: false,
      pdf_view: false,
      contract_id: null,
    }
  },
  computed: {
    resources () {
      return orderBy(this.row.contracts)
    },
    columns () {
      return [
        {
          title: this.$t('employee.contractStartDate'),
          key: 'contract_start_date',
          sortable: true,
          width: 200
        },
        {
          title: this.$t('employee.period'),
          key: 'contract_period',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('employee.expiredate'),
          key: 'contract_expire_date',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('employee.guarantorName'),
          key: 'guarantor_name',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('employee.guarantorName2'),
          key: 'guarantor_name_2',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('employee.province'),
          key: 'grt_province_code_name_en',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('employee.district'),
          key: 'grt_district_code_name_en',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('employee.commune'),
          key: 'grt_commune_code_name_en',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('employee.village'),
          key: 'grt_village_name_en',
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          align: 'center',
          width: 150
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('humanResource/employee/fetch', attributes)
        .catch(error => {
          this.loading = false
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.loading = false
        })
    },
    onPreviewPdf (record) {
      this.pdf_view = true
      this.contract_id = record.contract_id
    }
  }
}
</script>
<!-- 
<style lang="css">
.ivu-table-fixed-shadow {
  pointer-events: none !important;
}
</style> -->
